import { render } from "./AdminAccountCreateForm.vue?vue&type=template&id=e0e6c1b6&lang=true"
import script from "./AdminAccountCreateForm.vue?vue&type=script&lang=js"
export * from "./AdminAccountCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__